import React, { useState, useEffect } from "react";
import { Icon, Flyout, Button } from '@a-ui/react';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { selectTask } from '../../store/slices/tasksReducer'
import TaskFlyout from './TaskFlyout'
import Location from '../Location/Location'
import MapWrapper from '../MapWrapper/MapWrapper'
import Html from '../Html/Html'
import Assignments from '../Assignments/Assignments'
import { getAvailableActions, hasAnyStartedAssignment } from '../../helpers/task.helper';
import { formatDateTime } from '../../helpers/dateTime.helper';
import { tasksToMarker } from '../../helpers/taskToMarker.helper';
import { getActiveTasksForUser } from '../../helpers/task.helper';

import '../../styles/map.scss';

const Map = (props) => {
  const userLocation = useSelector(state => state.userLocation);
  const dispatch = useDispatch();
  const tasks = useSelector(state => state.tasks);
  const { user } = useSelector(state => state.user);
  const { selectedTask, filters } = tasks;
  const { domains } = useSelector(state => state.domains);
  const [open, setOpen] = useState(false);
  const [openActions, setOpenActions] = useState(false);
  const modal = useSelector(state => state.modal);
  const { data } = useSelector(state => state.tasks)
  const { activeTasks, otherTasks } = getActiveTasksForUser(data, user.userName)
  const filteredtasks = [
    ...activeTasks,
    ...otherTasks,
  ];
  const markers = tasksToMarker(filteredtasks, selectedTask);
  const task = markers.find((marker) => marker.data.id === selectedTask);
  const actions = getAvailableActions(task?.data, user, false, () => {}, dispatch);
  const { pause } = actions;
  useEffect(() => {
    if(modal.success && !modal.open) {
      setOpen(false);
    }
  }, [modal.success, modal.open]);
  const layers = domains.filter((domain) => {
    if(!filters.domain) return true;
    return filters.domain?.value === domain.id.toString();
  }).reduce((acc, { layers }) => {
    return [ ...acc, ...layers ];
  }, []);
  let location = undefined;
  if(userLocation.location) {
    location = [userLocation.location.latitude, userLocation.location.longitude];
  }
  return <div className={`u-margin-top u-margin-bottom mapholder ${ open ? 'open' : '' }`}>
    <MapWrapper
      markers={markers}
      layers={layers}
      location={location}
      onFilteredResult={(x) => {
        dispatch(selectTask(x[0].data.id));
        setOpen(true);
      }}
    />

    <div className="taskDetail">
      <div className="row u-margin-top u-margin-right-s u-margin-left-s">
        <div className="col-xs-12 u-margin-bottom-xs test u-text-right">
          <Icon name="ai-remove" className="close pointer" onClick={() => setOpen(!open)}/>
        </div>
      </div>
      <div className="u-margin-top-xs u-margin-right-s u-margin-left-s row taskContent">
        <div className="col-xs-12 u-margin-bottom-l">
          <div className="u-margin-bottom-s h3">
            <Link to={`/task/${task?.data?.id}`} className="h3">{task?.data?.name}</Link>
          </div>
            { task?.data?.active && !hasAnyStartedAssignment(task?.data?.taskAssignments) && (
              <span className="a-label a-label--success u-margin-bottom-xs">
                Gepauzeerd
              </span>
            )}
            { task?.data?.active && hasAnyStartedAssignment(task?.data?.taskAssignments) && (
              <span className="a-label a-label--success u-margin-bottom-xs">
                Gestart
              </span>
            )}
          <p className="u-margin-bottom-xs">
            <Location location={task?.data?.locationDuringAssignment} />
          </p><br/>
          <p className="u-margin-bottom-xs">
            <Icon name="ai-calendar-3" className="u-margin-right-xxs"/>Uiterste datum: {formatDateTime(task?.data?.dueDate)}
          </p><br/>
          <p className="u-margin-bottom-xs">
            <Icon name="ai-copy-paste-1" className="u-margin-right-xxs"/>{task?.data?.taskType}
          </p>
        </div>
        <div className="col-xs-12 u-margin-bottom-xl">
          <small className="a-input__description" id="text-field-description">Toegekende personen</small>
          <div className="u-margin-bottom-xs">
            <Assignments assignments={task?.data?.taskAssignments} />
          </div>
          <div className="description">
            <div>
              <small>Foto's</small>
              <p className="u-margin-bottom-xs">
                <Icon name="ai-copy-paste-1" className="u-margin-right-xxs"/>1
              </p>
            </div>
            <div className="u-margin-right-xs">
              <small>Beschrijving</small>
              <Html>{task?.data?.description}</Html>
            </div>
          </div>
        </div>
      </div>
      <div className="row u-margin-right-s u-margin-left-s ">
        <div className="col-xs-12 actionbutton">
          <Flyout
            orientation="upper-left"
            hasPadding={false}
            open={openActions}
            onStateChange={() => setOpenActions(!openActions)}
            size="small"
            trigger={
              <Button
                className={`a-button marginright ${ !task?.data?.active && "a-button--outlined"} ${task?.data?.active && "a-button--success"}`}
                iconRight="ai-navigation-menu-vertical"
                aria-label="Open actions"
                addOn={{
                  type: "icon",
                  align: "right",
                  iconProps: {
                    name: "ai-arrow-down-1",
                  },
                }}
              >
                Actie
              </Button>
            }
          >
            <TaskFlyout task={task?.data} onAction={() => setOpenActions(false)}  />
          </Flyout>
        </div>
    </div>
    </div>
  </div>
}
export default Map;
